// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
    firebase: {
      apiKey: 'AIzaSyAwxVyIrYWViQd72Yzjizv6CEtKdMr9_HA',
      authDomain: 'portfolio-andimanieta.firebaseapp.com',
      databaseURL: 'https://portfolio-andimanieta-default-rtdb.europe-west1.firebasedatabase.app',
      projectId: 'portfolio-andimanieta',
      storageBucket: 'portfolio-andimanieta.appspot.com',
      messagingSenderId: '706174427812',
      appId: '1:706174427812:web:65062ddc2ca02f691f7c31',
      measurementId: 'G-2DYWJVCYZL'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
